import posthog from 'posthog-js';

const KEY = process.env.REACT_APP_POSTHOG_KEY;

export function initPostHog() {
  if (!KEY) return;
  try {
    posthog.init(KEY, {
      api_host: 'https://us.i.posthog.com',
      autocapture: true,
      capture_pageview: true,
      session_recording: { maskAllInputs: true },
    });
  } catch (_) {}
}

export function phIdentify(usuario, empresa) {
  if (!KEY) return;
  try {
    posthog.identify(usuario.id, {
      email: usuario.email,
      nombre: usuario.nombre,
      rol: usuario.rol,
      plan: empresa?.plan || null,
      empresaId: usuario.empresaId || null,
    });
  } catch (_) {}
}

export function phReset() {
  if (!KEY) return;
  try { posthog.reset(); } catch (_) {}
}

export function phCapture(evento, props) {
  if (!KEY) return;
  try { posthog.capture(evento, props); } catch (_) {}
}
